import { defineStore } from 'pinia'
import { getLoginInfo } from '@/util/http'

/**
 * 将前端页面路径映射为后端权限
 */
const pageMap = {
  home: true
}

/**
 * 权限存储
 */
export const useAuthStore = defineStore('auth', {
  state: () => ({
    /**
     * 前缀匹配的权限码
     */
    prefix: [],
    /**
     * 是否为管理员(拥有所有权限)
     */
    admin: false
  }),
  actions: {
    init() {
      try {
        const loginInfo = getLoginInfo()
        if (loginInfo?.auth) {
          this.refresh(loginInfo.auth)
        }
      } catch (error) {
        console.error('恢复权限失败:', error)
      }
    },
    refresh({ admin, permissions }) {
      this.clear()
      if (admin) {
        this.admin = true
        return
      }
      this.prefix = permissions ?? []
    },
    clear() {
      this.prefix = []
      this.admin = false
    },
    has(uri) {
      return this.admin || this.prefix.some((it) => uri === it || uri.startsWith(it + '/'))
    },
    hasAny(uris) {
      return this.admin || uris.some((it) => this.has(it))
    },
    hasAll(uris) {
      return this.admin || uris.every((it) => this.has(it))
    },
    /**
     * 判断是否有指定页面的访问权限
     * @param {string} path 路由路径
     */
    hasPage(path) {
      if (this.admin) {
        return true
      }
      const uri = pageMap[path]
      if (uri === undefined) {
        return this.has(path)
      } else if (uri === true) {
        return true
      } else if (typeof uri === 'string') {
        return this.has(uri)
      } else if (Array.isArray(uri)) {
        return this.hasAny(uri)
      } else {
        throw new Error('未实现')
      }
    }
  }
})
